/* ============================================================
   FINE by MER'S — homepage behaviour
   Each block is independent so sections can be lifted into
   separate Shopify section assets without untangling anything.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Intro wordmark ENTRY treatment: 'A' fade-up (default), 'B' blur,
     'C' rise from below. The line no longer exits — it flies to the hero. */
  var INTRO_VARIANT = 'A';

  /* ============================================================
     COLLECTION DATA — built from the Liquid-rendered cards.
     Shopify renders every product into the grid; each .pcard carries
     data-tags / data-title / data-price. Karat, kesim and kategori
     are parsed from those attributes, so merchandising in the admin
     (titles, tags, prices) is the single source of truth.
     ============================================================ */
  var STICKY_FILTERBAR = true;   // set false to disable the sticky filter bar

  var PRICE_BANDS = [
    { id:'f0', label:'50.000 TL altı',      min:0,      max:50000 },
    { id:'f1', label:'50.000–150.000 TL',   min:50000,  max:150000 },
    { id:'f2', label:'150.000 TL üzeri',    min:150000, max:Infinity }
  ];

  /* Parse one rendered card into a product record. Fail-open: a field
     that cannot be parsed becomes null and simply never matches. */
  function parseCard(el) {
    var title = el.getAttribute('data-title') || '';
    var lower = title.toLocaleLowerCase('tr-TR');
    var karat = null;
    /* Karat artık başlıkta yok, metin ayrıştırmaya da güvenmiyoruz —
       "Toplam Karat" metafield'ından (data-pcarat) doğrudan sayı olarak
       okunuyor. Çoklu taşlı ürünlerde doğru toplam, karat girilmemiş
       üründe boş kalır (sıralamada sona düşer). */
    var pcaratAttr = el.getAttribute('data-pcarat') || '';
    if (pcaratAttr) {
      var pc = parseFloat(pcaratAttr.replace(',', '.'));
      if (!isNaN(pc)) karat = pc;
    }
    if (karat == null) {
      var m = lower.match(/(\d+(?:[.,]\d+)?)\s*(?:ct|karat|kt)\b/);
      if (m) karat = parseFloat(m[1].replace(',', '.'));
    }
    var category = null;
    var tags = (el.getAttribute('data-tags') || '').toLocaleLowerCase('tr-TR');
    if (tags.indexOf('yüzük') > -1 || lower.indexOf('yüzük') > -1) category = 'yuzuk';
    else if (tags.indexOf('küpe') > -1 || lower.indexOf('küpe') > -1) category = 'kupe';
    else if (tags.indexOf('kolye') > -1 || lower.indexOf('kolye') > -1) category = 'kolye';
    else if (tags.indexOf('bileklik') > -1 || lower.indexOf('bileklik') > -1) category = 'bileklik';
    var cuts = [];
    [['yuvarlak','yuvarlak'], ['oval','oval'], ['damla','damla'], ['markiz','markiz'],
     ['yastık','yastik'], ['zümrüt','zumrut'], ['prenses','prenses']].forEach(function (c) {
      if (lower.indexOf(c[0]) > -1) cuts.push(c[1]);
    });
    var price = parseFloat(el.getAttribute('data-price'));
    if (!price || isNaN(price)) price = null;
    return {
      id: el.getAttribute('data-id'),
      name: title,
      category: category,
      karat: karat,
      cuts: cuts,
      price: price,
      isNew: tags.indexOf('yeni') > -1
    };
  }

  /* --------------------------------------------------------
     PRICE GUARD — koleksiyon kartlarındaki indirimli fiyat yapısını
     (üstü çizili eski fiyat + yeni fiyat) her ne olursa olsun korur.
     Sayfada başka bir script bu elemanın içini silip düz metinle
     değiştirse bile, bu bekçi veriyi data-cprice/data-xprice'tan
     okuyup yapıyı geri kurar — bir kereye mahsus değil, sayfa
     boyunca sürekli izler (MutationObserver). Hangi script sildiği
     önemli değil, sonuç her zaman doğru kalır. -------------------------------------------------------- */
  (function priceGuard() {
    function fmt(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return '';
      return n.toLocaleString('tr-TR', { maximumFractionDigits: 0 }) + ' TL';
    }
    function build(el) {
      var cp = el.getAttribute('data-cprice');
      if (!cp) return;
      var xp = el.getAttribute('data-xprice');
      var html;
      if (xp) {
        html = '<s class="price__compare" data-tl="' + xp + '">' + fmt(xp) + '</s>' +
               '<span class="price__now" data-tl="' + cp + '">' + fmt(cp) + '</span>';
      } else {
        html = '<span data-tl="' + cp + '">' + fmt(cp) + '</span>';
      }
      if (el.getAttribute('data-guarded-html') !== html) {
        el.innerHTML = html;
        el.setAttribute('data-guarded-html', html);
      }
    }
    function guardAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-price-guard]'), build);
    }
    guardAll();
    document.addEventListener('DOMContentLoaded', guardAll);
    window.addEventListener('load', guardAll);
    window.setTimeout(guardAll, 300);
    window.setTimeout(guardAll, 1000);
    window.setTimeout(guardAll, 3000);
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { guardAll(); });
      var start = function () {
        Array.prototype.forEach.call(document.querySelectorAll('[data-price-guard]'), function (el) {
          mo.observe(el, { childList: true, characterData: true, subtree: true });
        });
        var grid = document.querySelector('.pgrid');
        if (grid) mo.observe(grid, { childList: true, subtree: true });
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }
    }
  })();

  /* --------------------------------------------------------
     THE LOOK — a rotation of looks. Each slide wires its own dots
     (projected through the cover crop), its thumbnail crops, and its
     plate entries; the controller crossfades between slides.
     -------------------------------------------------------- */
  (function looks() {
    var roots = document.querySelectorAll('.look');
    if (!roots.length) return;
    var touch = window.matchMedia('(hover: none)').matches;

    function wireSlide(slide) {
      var media = slide.querySelector('[data-look-media]');
      var img = null;
      if (media) {
        for (var ci = 0; ci < media.children.length; ci++) {
          if (media.children[ci].tagName === 'IMG') { img = media.children[ci]; break; }
        }
      }
      var dots = slide.querySelectorAll('.look__dot');

      function placeDots() {
        if (!img || !media) return;
        var iw = img.naturalWidth || parseFloat(img.getAttribute('width'));
        var ih = img.naturalHeight || parseFloat(img.getAttribute('height'));
        var cw = media.clientWidth, chh = media.clientHeight;
        if (!iw || !ih || !cw || !chh) return;
        var sc = Math.max(cw / iw, chh / ih);
        var dw = iw * sc, dh = ih * sc;
        var ox = (cw - dw) / 2, oy = (chh - dh) / 2;
        Array.prototype.forEach.call(dots, function (dot) {
          var x = ox + parseFloat(dot.getAttribute('data-ix')) / 100 * dw;
          var y = oy + parseFloat(dot.getAttribute('data-iy')) / 100 * dh;
          dot.style.left = Math.round(x) + 'px';
          dot.style.top = Math.round(y) + 'px';
          dot.classList.toggle('look__dot--flip', x > cw * 0.55);
        });
      }
      placeDots();
      if (img && !img.complete) img.addEventListener('load', placeDots);

      function cropAll() {
        Array.prototype.forEach.call(slide.querySelectorAll('.look__media2 img'), function (tImg) {
          if (tImg.getAttribute('data-cropped')) return;
          function cropToJewel() {
            if (tImg.getAttribute('data-cropped')) return;
            var fallback = 'scale(1.5)';
            try {
              var N = 64;
              var c = document.createElement('canvas');
              c.width = N; c.height = N;
              var ctx = c.getContext('2d', { willReadFrequently: true });
              ctx.drawImage(tImg, 0, 0, N, N);
              var d = ctx.getImageData(0, 0, N, N).data;
              var x0 = N, y0 = N, x1 = -1, y1 = -1;
              for (var y = 0; y < N; y++) {
                for (var x = 0; x < N; x++) {
                  var i = (y * N + x) * 4;
                  if (Math.min(d[i], d[i + 1], d[i + 2]) < 236) {
                    if (x < x0) x0 = x;
                    if (x > x1) x1 = x;
                    if (y < y0) y0 = y;
                    if (y > y1) y1 = y;
                  }
                }
              }
              if (x1 < 0) { tImg.style.transform = fallback; tImg.setAttribute('data-cropped', '1'); return; }
              var bw = (x1 - x0 + 1) / N, bh = (y1 - y0 + 1) / N;
              var cx = (x0 + x1 + 1) / 2 / N, cy = (y0 + y1 + 1) / 2 / N;
              var sc = Math.min(2.6, Math.max(1, 0.84 / Math.max(bw, bh)));
              tImg.style.transformOrigin = (cx * 100) + '% ' + (cy * 100) + '%';
              tImg.style.transform = 'translate(' + ((0.5 - cx) * 100).toFixed(1) + '%, ' + ((0.5 - cy) * 100).toFixed(1) + '%) scale(' + sc.toFixed(2) + ')';
              tImg.setAttribute('data-cropped', '1');
            } catch (e) {
              tImg.style.transform = fallback;
              tImg.setAttribute('data-cropped', '1');
            }
          }
          if (tImg.complete && tImg.naturalWidth > 0) cropToJewel();
          else tImg.addEventListener('load', cropToJewel);
        });
      }
      cropAll();

      var entries = slide.querySelectorAll('.look__card[data-x]');
      Array.prototype.forEach.call(entries, function (entry, i) {
        entry.addEventListener('mouseenter', function () {
          if (touch || !dots[i]) return;
          Array.prototype.forEach.call(slide.querySelectorAll('.look__dot.is-open'), function (d) {
            d.classList.remove('is-open');
          });
          dots[i].classList.add('is-open');
        });
        entry.addEventListener('mouseleave', function () {
          if (dots[i]) dots[i].classList.remove('is-open');
        });
      });

      Array.prototype.forEach.call(dots, function (dot) {
        if (touch) {
          dot.addEventListener('click', function (e) {
            if (dot.classList.contains('is-open')) return;
            e.preventDefault();
            Array.prototype.forEach.call(slide.querySelectorAll('.look__dot.is-open'), function (d) {
              d.classList.remove('is-open');
            });
            dot.classList.add('is-open');
          });
        }
        dot.addEventListener('mouseleave', function () { dot.classList.remove('is-open'); });
      });

      return { placeDots: placeDots, cropAll: cropAll, media: media, img: img };
    }

    Array.prototype.forEach.call(roots, function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-look-slide]'));
      if (!slides.length) return;
      var api = slides.map(wireSlide);

      var lookRAF;
      window.addEventListener('resize', function () {
        window.cancelAnimationFrame(lookRAF);
        lookRAF = window.requestAnimationFrame(function () {
          api.forEach(function (a) { a.placeDots(); });
        });
      });

      var nav = root.querySelector('[data-look-nav]');
      if (!nav || slides.length < 2) return;
      nav.hidden = false;
      var count = nav.querySelector('[data-look-count]');
      var at = 0;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function sync() { if (count) count.textContent = pad(at + 1) + ' / ' + pad(slides.length); }
      sync();

      function show(n) {
        at = (n + slides.length) % slides.length;
        slides.forEach(function (sl, i) {
          var on = i === at;
          sl.classList.toggle('is-active', on);
          sl.classList.remove('is-entering');
          if (on) {
            void sl.offsetWidth;
            sl.classList.add('is-entering');
            window.setTimeout(function () { sl.classList.remove('is-entering'); }, 1600);
            api[i].placeDots();
            api[i].cropAll();
            if (api[i].img && api[i].img.loading === 'lazy') api[i].img.loading = 'eager';
            sl.removeAttribute('aria-hidden');
          } else {
            sl.setAttribute('aria-hidden', 'true');
          }
        });
        sync();
      }
      nav.querySelector('[data-look-prev]').addEventListener('click', function () { show(at - 1); });
      nav.querySelector('[data-look-next]').addEventListener('click', function () { show(at + 1); });
    });

    var closeEvt = window.PointerEvent ? 'pointerdown' : 'touchstart';
    document.addEventListener(closeEvt, function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.look__dot')) return;
      Array.prototype.forEach.call(document.querySelectorAll('.look__dot.is-open'), function (d) {
        d.classList.remove('is-open');
      });
    }, true);
  })();

  /* --------------------------------------------------------
     PRICES — any element carrying data-tl gets the Turkish
     format; the Liquid money output inside is the fallback.
     -------------------------------------------------------- */
  (function tl() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tl]'), function (el) {
      var v = parseFloat(el.getAttribute('data-tl'));
      if (v > 0) el.textContent = v.toLocaleString('tr-TR', { maximumFractionDigits: 0 }) + ' TL';
    });
  })();

  /* --------------------------------------------------------
     HERO VIDEO — two cuts: a 9:16 vertical file for phones and a
     landscape file for desktop. Only the one matching the viewport
     gets a <source>, so neither device downloads the other's file.
     No desktop file → photo stays (unless the Customize switch
     forces the vertical cut onto desktop).
     -------------------------------------------------------- */
  (function heroVideo() {
    var v = document.querySelector('.hero__media video[data-video-src], .hero__media video[data-video-src-desktop]');
    if (!v) return;
    var mobile = window.matchMedia('(max-width:900px)').matches;
    var src = mobile ? v.getAttribute('data-video-src')
      : (v.getAttribute('data-video-src-desktop') ||
         (v.hasAttribute('data-video-desktop') ? v.getAttribute('data-video-src') : null));
    if (!src) { v.remove(); return; }
    var s = document.createElement('source');
    s.src = src;
    s.type = 'video/mp4';
    v.appendChild(s);
    v.load();   // intro sürerken arabelleğe alır, oynatmaz
    function go() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }   // engellenirse poster/foto kalır
    // Video intro bitince başlar: motion() perde kalkınca hero'ya is-loaded
    // ekler (intro yoksa / görülmüşse / reduced-motion'da hemen ekler).
    var hero = document.querySelector('[data-hero]');
    function ready() { return !hero || hero.classList.contains('is-loaded'); }
    if (ready()) go();
    else {
      var mo = new MutationObserver(function () { if (ready()) { mo.disconnect(); go(); } });
      mo.observe(hero, { attributes: true, attributeFilter: ['class'] });
    }
    // arka plan sekmesinde açılırsa tarayıcı bekletir — sekme görününce başlat
    document.addEventListener('visibilitychange', function () { if (!document.hidden && v.paused && ready()) go(); });
  })();

  /* --------------------------------------------------------
     HİKAYEMİZ — farm-tarzı bölüm animasyonları. Başlık ve
     numaralar kelime kelime maskeden yükselir, çizgiler soldan
     açılır, paragraflar yumuşak kalkar, fotoğraflar hafif
     paralaks yapar. reduced-motion'da hepsi statik.
     -------------------------------------------------------- */
  (function fmStory() {
    var root = document.querySelector('[data-fm]');
    if (!root) return;
    var still = reduced || !('IntersectionObserver' in window);

    Array.prototype.forEach.call(root.querySelectorAll('[data-fm-split]'), function (el) {
      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      words.forEach(function (w, i) {
        var m = document.createElement('span'); m.className = 'fm-mask';
        var s = document.createElement('span'); s.className = 'fm-word';
        s.style.transitionDelay = (i * 55) + 'ms';
        s.textContent = w;
        m.appendChild(s);
        el.appendChild(m);
        el.appendChild(document.createTextNode(' '));
      });
    });

    if (still) { root.classList.add('fm-still'); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('fm-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(root.querySelectorAll('[data-fm-rise]'), function (el) { io.observe(el); });

    var media = Array.prototype.slice.call(root.querySelectorAll('[data-fm-plx] img'));
    if (media.length) {
      var ticking = false;
      var plx = function () {
        ticking = false;
        var vh = window.innerHeight;
        media.forEach(function (img) {
          var r = img.parentNode.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          var d = (r.top + r.height / 2 - vh / 2) / vh;
          img.style.transform = 'translateY(' + (d * -6).toFixed(2) + '%) scale(1.12)';
        });
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(plx); }
      }, { passive: true });
      plx();
    }
  })();

  /* --------------------------------------------------------
     SEPETE EKLENDİ — ürün formunu AJAX'a çevirir ve onay
     penceresini açar (lululemon akışı). Fetch başarısız olursa
     form olduğu gibi /cart'a gider — asla çıkmaz sokak yok.
     -------------------------------------------------------- */
  /* montür seçimi gerçek varyantı sürer: gizli id alanı güncellenir.
     Not: önceden burada beyaz altın seçilince fotoğrafa CSS filtresi
     (saturate/brightness) uygulanıyordu — bu görsel değiştirme davranışı
     kasıtlı olarak kaldırıldı, artık sadece varyant id'si güncelleniyor. */
  (function variantPicker() {
    var picker = document.querySelector('[data-variant-picker]');
    var idField = document.querySelector('form.pa__ctas input[name="id"]');
    if (!picker || !idField) return;
    Array.prototype.forEach.call(picker.querySelectorAll('input[type="radio"]'), function (r) {
      r.addEventListener('change', function () {
        idField.value = r.value;
      });
    });
  })();

  (function atcModal() {
    var modal = document.querySelector('[data-atc]');
    var form = document.querySelector('form.pa__ctas');
    if (!modal || !form) return;

    function openModal(cart) {
      var count = modal.querySelector('[data-atc-count]');
      if (count) count.textContent = cart.item_count;
      var sub = modal.querySelector('[data-atc-subtotal]');
      if (sub) sub.textContent = (cart.total_price / 100).toLocaleString('tr-TR', { maximumFractionDigits: 0 }) + ' TL';
      var badge = document.querySelector('.nav__cartcount');
      if (badge) badge.textContent = cart.item_count;
      modal.hidden = false;
      document.documentElement.classList.add('is-locked');
      window.setTimeout(function () { modal.classList.add('is-open'); }, 20);
    }
    function closeModal() {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('is-locked');
      window.setTimeout(function () { modal.hidden = true; }, 380);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(openModal)
        .catch(function () { form.submit(); });
    });

    Array.prototype.forEach.call(modal.querySelectorAll('[data-atc-close]'), function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  })();

  /* --------------------------------------------------------
     NAV — transparent over hero, solid once scrolled past it
     -------------------------------------------------------- */
  (function nav() {
    var el = document.querySelector('[data-nav]');
    var hero = document.querySelector('[data-hero]');
    if (!el) return;

    // Inner pages have no hero to sit over: the bar is permanently solid.
    if (!hero) {
      el.classList.add('is-solid');
      return;
    }

    // A zero-height sentinel is placed at the point where the hero ends.
    // IntersectionObserver fires only when that line crosses the header, so
    // iOS rubber-band overscroll cannot make the bar flicker the way a
    // scroll handler does.
    var sentinel = document.createElement('div');
    sentinel.className = 'nav__sentinel';
    hero.style.position = hero.style.position || 'relative';
    sentinel.style.top = 'calc(100% - 1px)';
    hero.appendChild(sentinel);

    if (!('IntersectionObserver' in window)) {
      el.classList.add('is-solid');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        el.classList.toggle('is-solid', !e.isIntersecting);
      });
    }, { rootMargin: '-' + el.offsetHeight + 'px 0px 0px 0px', threshold: 0 });

    io.observe(sentinel);
  })();

  /* --------------------------------------------------------
     NAV — mobile drawer
     -------------------------------------------------------- */
  (function drawer() {
    var burger = document.querySelector('[data-burger]');
    var panel = document.querySelector('[data-drawer]');
    if (!burger || !panel) return;

    function set(open) {
      panel.hidden = !open;
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? 'Menüyü kapat' : 'Menüyü aç');
    }

    burger.addEventListener('click', function () {
      set(panel.hidden);
    });

    panel.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') set(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        set(false);
        burger.focus();
      }
    });
  })();

  /* --------------------------------------------------------
     MOTION — intro sequence + layered scroll reveals

     FAIL-OPEN CONTRACT: the .motion class is added to <html> from here.
     If this file never loads, never parses, or throws before this line,
     .motion is absent and every element renders at its final state.
     Nothing is hidden by CSS alone.
     -------------------------------------------------------- */
  (function motion() {
    var root = document.documentElement;
    var hero = document.querySelector('[data-hero]');
    var nav = document.querySelector('[data-nav]');

    /* ---- reduced motion: final state, no overlay, no lock ---- */
    if (reduced) {
      if (hero) hero.classList.add('is-loaded');
      if (nav) nav.classList.add('is-shown');
      Array.prototype.forEach.call(document.querySelectorAll('.reveal'), function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    root.classList.add('motion');
    // failsafe: the bar is never left invisible, whatever happens below
    window.setTimeout(function () { if (nav) nav.classList.add('is-shown'); }, 3000);

    /* =========================================================
       A. full-bleed media wrappers
       The triptych image also scales on :hover, so the entry scale
       goes on a wrapper — two transforms that never fight.
       ========================================================= */
    Array.prototype.forEach.call(document.querySelectorAll('.cat'), function (cat) {
      var img = cat.querySelector('img');
      if (!img || cat.querySelector('.cat__media')) return;
      var w = document.createElement('div');
      w.className = 'cat__media rv-scale';
      cat.insertBefore(w, img);
      w.appendChild(img);
    });
    Array.prototype.forEach.call(
      document.querySelectorAll('.storyband, .banner'), function (el) {
        el.classList.add('rv-media');
      });

    /* =========================================================
       B. tag headings, then build stagger groups
       ========================================================= */
    // A heading is "leading" whether it reveals on its own or as part of a
    // block that contains it. Both get the heavier 55px / 800ms treatment.
    Array.prototype.forEach.call(
      document.querySelectorAll('.h-display.reveal, .label.reveal'), function (el) {
        el.classList.add('reveal--head');
        el.style.setProperty('--d', '0ms');
      });
    Array.prototype.forEach.call(document.querySelectorAll('.reveal'), function (el) {
      if (el.querySelector('.h-display')) {
        el.classList.add('reveal--head');
        el.style.setProperty('--d', '0ms');
      }
    });

    // Non-heading reveals trail the heading by 100ms so the heading leads.
    Array.prototype.forEach.call(document.querySelectorAll('.reveal'), function (el) {
      if (!el.classList.contains('reveal--head') && !el.style.getPropertyValue('--d')) {
        el.style.setProperty('--d', '100ms');
      }
    });

    var STAGGER = ['.cats', '.pgrid', '.strip__grid', '.trust__list', '.foot__grid', '.edu__cols', '.look__cards'];
    var STEP = 170, MAX_STEPS = 6;
    var groups = [];

    STAGGER.forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (box) {
        var kids = Array.prototype.slice.call(box.children);
        if (!kids.length) return;
        kids.forEach(function (kid, i) {
          kid.classList.add('reveal');
          // after MAX_STEPS the remainder shares the last delay, so long
          // grids do not crawl
          var step = Math.min(i, MAX_STEPS - 1);
          kid.style.setProperty('--d', (step * STEP) + 'ms');
          if (kid.querySelector('.h-display')) kid.classList.add('reveal--head');
        });
        groups.push(box);
      });
    });

    /* =========================================================
       C. one observer for the whole page, unobserve after firing
       ========================================================= */
    var io = null;
    function showAll() {
      Array.prototype.forEach.call(
        document.querySelectorAll('.reveal, .rv-media, .rv-scale'), function (el) {
          el.classList.add('is-in');
        });
    }

    if (!('IntersectionObserver' in window)) {
      showAll();
    } else {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          // A block taller than the screen can never reach a 15% ratio — an
          // 85-product grid is ~9600px, so 15% is 1400px of a 750px viewport
          // and the reveal would never fire. Tall blocks qualify the moment
          // they touch the viewport; the per-child stagger does the rest.
          var vh = window.innerHeight || document.documentElement.clientHeight || 800;
          var tall = e.boundingClientRect.height > vh * 0.6;
          if (!tall && e.intersectionRatio < 0.15) return;
          var t = e.target;
          if (groups.indexOf(t) > -1) {
            Array.prototype.forEach.call(t.children, function (k) { k.classList.add('is-in'); });
          }
          t.classList.add('is-in');
          io.unobserve(t);                 // reveal once, never again
        });
      }, { threshold: [0, 0.15] });

      var watch = [];
      Array.prototype.forEach.call(document.querySelectorAll('.reveal'), function (el) {
        // children of a stagger group are fired by their container
        var inGroup = false;
        for (var i = 0; i < groups.length; i++) {
          if (groups[i] === el.parentNode) { inGroup = true; break; }
        }
        if (!inGroup) watch.push(el);
      });
      groups.forEach(function (g) { watch.push(g); });
      Array.prototype.forEach.call(document.querySelectorAll('.rv-media, .rv-scale'), function (el) {
        watch.push(el);
      });
      watch.forEach(function (el) { io.observe(el); });

      // Fail-open: whatever the observer missed, anything already on screen
      // is shown anyway. Content must never stay stuck at opacity 0.
      window.setTimeout(function () {
        var vh = window.innerHeight || document.documentElement.clientHeight || 800;
        Array.prototype.forEach.call(
          document.querySelectorAll('.reveal:not(.is-in), .rv-media:not(.is-in), .rv-scale:not(.is-in)'),
          function (el) {
            var r = el.getBoundingClientRect();
            if (r.top < vh && r.bottom > 0) {
              el.classList.add('is-in');
              if (groups.indexOf(el) > -1) {
                Array.prototype.forEach.call(el.children, function (k) { k.classList.add('is-in'); });
              }
            }
          });
      }, 2500);
    }

    /* =========================================================
       D. hero entrance
       ========================================================= */
    function heroIn(navDelay) {
      if (hero) hero.classList.add('is-loaded');
      window.setTimeout(function () {
        if (nav) nav.classList.add('is-shown');
      }, typeof navDelay === 'number' ? navDelay : 300);
    }

    /* =========================================================
       E. intro — the settled sequence.
         Act 1: the slogan, one plain centred line, word by word.
         Act 2: the words leave; the wordmark pops up alone.
         Act 3: the curtain lifts, the wordmark travels up into the
                header, and the hero copy builds on the right —
                headline, subline, links, button — by normal rise.
       No headline flight. Slogan and wordmark never share the frame.
       ========================================================= */
    var isHome = !!hero && !!document.querySelector('#pirlanta');
    var seen = false;
    try { seen = window.sessionStorage.getItem('fine_intro') === '1'; } catch (e) { seen = false; }

    if (!isHome || seen) {
      // the head script may have raised the curtain; nothing will use it
      root.classList.remove('introing');
      heroIn(300);
      return;
    }
    try { window.sessionStorage.setItem('fine_intro', '1'); } catch (e) {}

    /* ---- timings (ms) — deliberately unhurried ---- */
    /* The slogan IS the hero headline, read from the page rather than
       repeated here — edit it in Customize and the intro follows. */
    var titleEl = hero.querySelector('.hero__title');
    var titleTxt = titleEl ? (titleEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
    var WORDS = titleTxt ? titleTxt.split(' ') : ['Hayal', 'Ettiğiniz', 'Karat'];
    if (WORDS.length > 6) WORDS = [titleTxt];      // a long headline arrives whole
    var W_START = 500, W_GAP = 450, W_DUR = 900, HOLD1 = 350;
    var OUT_GAP = 100;
    var WM_POP = 550;          // wordmark blooms as the last word finishes leaving
    var HOLD2 = 800;
    var FLIGHT_WM = 1100;
    var t2 = W_START + W_GAP * (WORDS.length - 1) + W_DUR + HOLD1;   // ~2150

    var realWm = document.querySelector('.nav__wordmark');

    var overlay = document.createElement('div');
    overlay.className = 'intro';
    overlay.setAttribute('aria-hidden', 'true');
    var line = document.createElement('p');
    line.className = 'intro__line';
    var wordEls = WORDS.map(function (w, i) {
      var sp = document.createElement('span');
      sp.className = 'intro__word';
      sp.textContent = w;
      line.appendChild(sp);
      if (i < WORDS.length - 1) line.appendChild(document.createTextNode(' '));
      return sp;
    });
    overlay.appendChild(line);
    document.body.appendChild(overlay);

    var fly = document.createElement('div');
    fly.className = 'intro__fly in-a';
    fly.setAttribute('aria-hidden', 'true');
    ['FINE', 'by', 'MER\u2019S'].forEach(function (t, i) {
      var sp = document.createElement('span');
      if (i === 1) sp.className = 'fly-by';
      sp.textContent = t;
      fly.appendChild(sp);
    });
    document.body.appendChild(fly);

    if (realWm) realWm.style.visibility = 'hidden';

    root.classList.add('is-locked');
    /* Hand over from the CSS curtain to the real overlay. Both are the same
       ink and the overlay sits above it, so the swap cannot be seen — but
       the class must go now, or its ::before would still be there when the
       curtain lifts and would cover the site. */
    root.classList.remove('introing');
    var done = false;
    function unlock() { root.classList.remove('is-locked'); }
    function finish() {
      if (done) return;
      done = true;
      unlock();
      if (realWm) realWm.style.visibility = '';
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      if (fly.parentNode) fly.parentNode.removeChild(fly);
      if (hero) hero.classList.add('is-loaded');
      if (nav) nav.classList.add('is-shown');
    }
    window.setTimeout(unlock, 6500);   // hard cap — scroll is never locked past 6.5s
    window.setTimeout(finish, 8500);   // nothing intro-related survives past 8.5s

    /* right-side build order once the curtain lifts:
       headline first, then subline, then links, then the button.
       (CSS adds a 200ms base to each rise delay.) */
    var titleRise = document.querySelector('.hero__title .rise');
    if (titleRise) titleRise.style.setProperty('--d', '900ms');
    var subRise = document.querySelector('.hero__sub .rise');
    if (subRise) subRise.style.setProperty('--d', '1150ms');
    Array.prototype.forEach.call(
      document.querySelectorAll('.hero__actions .rise'),
      function (el) { el.style.setProperty('--d', '1350ms'); });
    Array.prototype.forEach.call(
      document.querySelectorAll('.hero__cta .rise'),
      function (el) { el.style.setProperty('--d', '1550ms'); });

    function runTimeline() {
      /* ---- act 1: the slogan, plain and centred ---- */
      wordEls.forEach(function (w, i) {
        window.setTimeout(function () { w.classList.add('is-on'); }, W_START + i * W_GAP);
      });

      /* ---- act 2: words leave; the wordmark pops up alone ---- */
      wordEls.forEach(function (w, i) {
        window.setTimeout(function () {
          w.classList.remove('is-on');
          w.classList.add('is-out');
        }, t2 + i * OUT_GAP);
      });
      window.setTimeout(function () {
        fly.style.left = Math.round((window.innerWidth - fly.offsetWidth) / 2) + 'px';
        fly.style.top = Math.round((window.innerHeight - fly.offsetHeight) / 2) + 'px';
        fly.classList.add('is-in');
      }, t2 + WM_POP);

      var t3 = t2 + WM_POP + 900 + HOLD2;    // ~6000

      /* ---- act 3: curtain lifts, wordmark rises home, hero builds ---- */
      window.setTimeout(function () {
        if (done) return;
        unlock();
        overlay.classList.add('is-lifting');

        window.setTimeout(function () { if (hero) hero.classList.add('is-loaded'); }, 250);
        window.setTimeout(function () { if (nav) nav.classList.add('is-shown'); }, 700);

        var targetW = realWm ? realWm.getBoundingClientRect() : null;
        if (targetW && targetW.width) {
          var fromW = fly.getBoundingClientRect();
          fly.style.transition =
            'transform ' + FLIGHT_WM + 'ms cubic-bezier(0.76, 0, 0.24, 1), ' +
            'color 250ms linear ' + (FLIGHT_WM - 250) + 'ms';
          fly.style.transform =
            'translate(' + (targetW.left - fromW.left).toFixed(2) + 'px,' +
                           (targetW.top - fromW.top).toFixed(2) + 'px) scale(' +
                           (targetW.width / fromW.width).toFixed(4) + ')';
          fly.style.color = window.getComputedStyle(realWm).color;
          window.setTimeout(function () {
            if (realWm) realWm.style.visibility = '';
            if (fly.parentNode) fly.parentNode.removeChild(fly);
            window.setTimeout(finish, 50);
          }, FLIGHT_WM);
        } else {
          fly.style.transition = 'opacity 400ms linear';
          fly.style.opacity = '0';
          window.setTimeout(function () {
            if (realWm) realWm.style.visibility = '';
            if (fly.parentNode) fly.parentNode.removeChild(fly);
            window.setTimeout(finish, 50);
          }, 420);
        }
      }, t3);
    }

    var fontsReady;
    try {
      fontsReady = Promise.race([
        Promise.all([
          document.fonts.load('400 1em "Cormorant Garamond"'),
          document.fonts.load('500 1em Figtree')
        ]),
        new Promise(function (res) { window.setTimeout(res, 900); })
      ]);
    } catch (e) { fontsReady = Promise.resolve(); }
    fontsReady.then(runTimeline, runTimeline);
  })();

  /* --------------------------------------------------------
     KARAT REHBERİ — true-scale carat guide
     Round-brilliant diameter follows the standard cube-root
     relationship: a 1.00 ct round brilliant is ~6.5 mm, and
     diameter scales with the cube root of weight.
     -------------------------------------------------------- */
  (function caratGuide() {
    var root = document.querySelector('[data-carat]');
    if (!root) return;

    var MM_AT_ONE_CT = 6.5;
    var FINGER_MM = 17;      // average ring-finger width
    var CARD_MM = 85.6;      // ISO/IEC 7810 ID-1 bank card
    var COMPARE_PX_PER_MM = 22;

    var range = root.querySelector('[data-carat-range]');
    var readout = root.querySelector('[data-carat-readout]');
    var stone = root.querySelector('[data-carat-stone]');
    var finger = root.querySelector('[data-carat-finger]');
    var toggle = root.querySelector('[data-carat-real]');
    var calib = root.querySelector('[data-carat-calib]');
    var card = root.querySelector('[data-carat-card]');
    var cardRange = root.querySelector('[data-carat-cardrange]');

    var realSize = false;
    var cardPx = parseFloat(cardRange.value);

    var nf = function (v, d) {
      return v.toLocaleString('tr-TR', { minimumFractionDigits: d, maximumFractionDigits: d });
    };

    /* Round-brilliant plan view, drawn once into the 0..200 viewBox.
       Skipped when the stone is a rendered image rather than an SVG —
       the sizing below drives either the same way. */
    (function drawStone() {
      if (!stone || String(stone.tagName).toLowerCase() !== 'svg') return;
      var cx = 100, cy = 100, R = 98, T = 56; // girdle radius, table radius
      var ns = 'http://www.w3.org/2000/svg';
      var frag = document.createDocumentFragment();

      function el(name, attrs) {
        var n = document.createElementNS(ns, name);
        for (var k in attrs) n.setAttribute(k, attrs[k]);
        return n;
      }
      function pt(r, aDeg) {
        var a = (aDeg - 90) * Math.PI / 180;
        return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
      }

      frag.appendChild(el('circle', { cx: cx, cy: cy, r: R, class: 'st-face' }));
      frag.appendChild(el('circle', { cx: cx, cy: cy, r: R, class: 'st-line' }));
      frag.appendChild(el('circle', { cx: cx, cy: cy, r: R - 7, class: 'st-line' })); // girdle

      // octagonal table
      var table = [];
      for (var i = 0; i < 8; i++) table.push(pt(T, i * 45 + 22.5));
      frag.appendChild(el('polygon', {
        points: table.map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' '),
        class: 'st-line'
      }));

      // bezel facets: table corners out to the girdle
      for (var j = 0; j < 8; j++) {
        var a = j * 45 + 22.5;
        var p1 = pt(T, a), p2 = pt(R - 7, a);
        frag.appendChild(el('line', { x1: p1[0].toFixed(1), y1: p1[1].toFixed(1), x2: p2[0].toFixed(1), y2: p2[1].toFixed(1), class: 'st-line' }));
      }
      // star facets: table edge midpoints out to the girdle
      for (var k = 0; k < 8; k++) {
        var b = k * 45;
        var q1 = pt(T * Math.cos(22.5 * Math.PI / 180), b), q2 = pt(R - 7, b);
        frag.appendChild(el('line', { x1: q1[0].toFixed(1), y1: q1[1].toFixed(1), x2: q2[0].toFixed(1), y2: q2[1].toFixed(1), class: 'st-line' }));
      }

      stone.appendChild(frag);
    })();

    var stage = root.querySelector('.carat__stage');

    function pxPerMm() {
      if (realSize) return cardPx / CARD_MM;
      // Comparison view scales down on narrow screens so the 17 mm finger
      // never exceeds the column and push the page into horizontal scroll.
      var avail = stage ? stage.clientWidth : 0;
      if (!avail) return COMPARE_PX_PER_MM;
      return Math.min(COMPARE_PX_PER_MM, avail / (FINGER_MM * 1.06));
    }

    function render() {
      var ct = parseFloat(range.value);
      var mm = MM_AT_ONE_CT * Math.cbrt(ct);
      var scale = pxPerMm();

      var stonePx = mm * scale;
      var fingerPx = FINGER_MM * scale;

      stone.style.width = stonePx + 'px';
      stone.style.height = stonePx + 'px';
      finger.style.width = fingerPx + 'px';
      finger.style.height = Math.max(fingerPx * 0.8, stonePx * 1.25) + 'px';

      readout.innerHTML = '<b>' + nf(ct, 2) + ' ct</b> <span>· ' + nf(mm, 1) + ' mm çap</span>';
      range.setAttribute('aria-valuetext', nf(ct, 2) + ' karat, ' + nf(mm, 1) + ' milimetre çap');
    }

    range.addEventListener('input', render);

    toggle.addEventListener('click', function () {
      realSize = !realSize;
      toggle.setAttribute('aria-pressed', String(realSize));
      toggle.textContent = realSize ? 'Karşılaştırma görünümü' : 'Gerçek boyutta göster';
      calib.hidden = !realSize;
      render();
    });

    cardRange.addEventListener('input', function () {
      cardPx = parseFloat(cardRange.value);
      card.style.width = cardPx + 'px';
      render();
    });

    var rAF;
    window.addEventListener('resize', function () {
      window.cancelAnimationFrame(rAF);
      rAF = window.requestAnimationFrame(render);
    });

    card.style.width = cardPx + 'px';
    render();
  })();

  /* --------------------------------------------------------
     PDP GALLERY — thumbnail swaps the main image
     -------------------------------------------------------- */
  (function gallery() {
    var root = document.querySelector('[data-gallery]');
    if (!root) return;

    var main = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    if (!main || !thumbs.length) return;

    Array.prototype.forEach.call(thumbs, function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-thumb');
        Array.prototype.forEach.call(thumbs, function (b) {
          b.setAttribute('aria-current', String(b === btn));
        });
      });
    });
  })();

  /* --------------------------------------------------------
     NEWSLETTER — front-end only; Shopify form replaces this
     -------------------------------------------------------- */
  (function newsletter() {
    var form = document.querySelector('[data-news]');
    if (!form) return;

    var msg = form.querySelector('[data-news-msg]');
    var input = form.querySelector('input[type="email"]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var value = (input.value || '').trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);

      if (!valid) {
        msg.textContent = 'Lütfen geçerli bir e-posta adresi girin.';
        input.focus();
        return;
      }

      msg.textContent = 'Teşekkürler. Kaydınız alındı.';
      form.reset();
    });
  })();

  /* --------------------------------------------------------
     LANGUAGE SWITCHER — artık gerçek: [data-lang] içindeki butonlar
     Shopify'ın locale_code form'unu submit ediyor (bkz. fine-header.liquid).
     Önceden burada, EN çevirisi henüz yokken tüm tıklamaları iptal eden
     (e.preventDefault) bir blok vardı — o kasıtlı kilit kaldırıldı,
     çünkü artık gerçek bir dil değiştirme işlevi var ve engellenmemeli.
     -------------------------------------------------------- */

  /* --------------------------------------------------------
     PRODUCT CARD — cross-fade to an on-skin shot.
     Generic: driven by data-alt on the card. Cards without the
     attribute simply never swap. Tap toggles it on touch devices.
     -------------------------------------------------------- */
  (function cardSwap() {
    var cards = document.querySelectorAll('.pcard[data-alt]');
    if (!cards.length) return;

    Array.prototype.forEach.call(cards, function (card) {
      var src = card.getAttribute('data-alt');
      if (!src) return;
      var media = card.querySelector('.pcard__media');
      if (!media || media.querySelector('.pcard__alt')) return;

      var img = document.createElement('img');
      img.className = 'pcard__alt';
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      img.setAttribute('aria-hidden', 'true');
      media.appendChild(img);

      // touch: first tap reveals, second follows the link
      var touched = false;
      card.addEventListener('touchstart', function () {
        if (!touched) { touched = true; card.classList.add('is-shown'); }
      }, { passive: true });
      card.addEventListener('mouseleave', function () {
        touched = false; card.classList.remove('is-shown');
      });
    });
  })();

  /* --------------------------------------------------------
     PRODUCT PAGE — metal finish selector.
     Same mechanism as the collection viewer: all photography is
     18k yellow gold, so alternates are colour transforms and are
     labelled as indicative on the page.
     -------------------------------------------------------- */
  (function finish() {
    var root = document.querySelector('[data-finish]');
    if (!root) return;
    var targets = document.querySelectorAll('[data-finish-target] img');
    if (!targets.length) return;

    Array.prototype.forEach.call(root.querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-filter') || 'none';
        Array.prototype.forEach.call(root.querySelectorAll('button'), function (o) {
          o.setAttribute('aria-current', String(o === b));
        });
        Array.prototype.forEach.call(targets, function (t) { t.style.filter = f; });
      });
    });
  })();

  /* --------------------------------------------------------
     COLLECTION FILTERS — koleksiyon.html only.
     Flat grid; category is a filter, never a heading. Groups OR
     within, AND across. Live apply, URL replaceState, faceted
     counts, desktop dropdowns + mobile sheet.
     -------------------------------------------------------- */
  (function filters() {
    var grid = document.querySelector('.pgrid');
    var side = document.querySelector('[data-flx-side]');
    if (!grid || !side) return;

    /* Ürün = üst seviye (etiket VEYA başlıktan). Kategori = şirket şeması;
       "bare" olanlar ürün adıyla aynı kategorilerdir: ürün etiketi olup
       kardeş kategori etiketi OLMAYAN parçalar oraya düşer, böylece aile
       alt etiketleri girene kadar da sayımlar anlamlı kalır. */
    /* Seçenekler Customize'dan gelir (data-o-*). Her satır bir seçenek,
       alanlar | ile ayrılır. Ayar boşsa Liquid varsayılanı zaten dolu. */
    var barEl0 = document.querySelector('[data-flx-bar]');
    var bd0 = (barEl0 && barEl0.dataset) || {};
    function rows(attr) {
      return (bd0[attr] || '').split(String.fromCharCode(10))
        .map(function (l) { return l.split('|').map(function (c) { return c.trim(); }); })
        .filter(function (c) { return c[0]; });
    }
    function slug(t) {
      return t.toLocaleLowerCase('tr-TR')
        .replace(/ğ/g,'g').replace(/ü/g,'u').replace(/ş/g,'s')
        .replace(/ı/g,'i').replace(/ö/g,'o').replace(/ç/g,'c')
        .replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
    }

    var URUNS = rows('oUrun').map(function (c) {
      return { id: slug(c[1] || c[0]), label: c[0], tag: (c[1] || c[0]).toLocaleLowerCase('tr-TR') };
    });
    var KATS = rows('oKategori').map(function (c, i) {
      var tag = (c[1] || c[0]).toLocaleLowerCase('tr-TR');
      var parent = (c[2] || '').toLocaleLowerCase('tr-TR');
      return {
        id: slug(c[0]) + '-' + i, label: c[0], tag: tag,
        parent: slug(parent || tag),
        bare: /evet|bare|true/i.test(c[3] || '')
      };
    });
    var PRICE_BANDS_LIVE = rows('oFiyat').map(function (c, i) {
      var mn = parseFloat((c[1] || '0').replace(/[^0-9.]/g, '')) || 0;
      var mxRaw = (c[2] || '').replace(/[^0-9.]/g, '');
      return { id: 'f' + i, label: c[0], min: mn, max: mxRaw ? parseFloat(mxRaw) : Infinity };
    });
    var MONTURS = rows('oMontur').map(function (c) {
      return { id: (c[1] || 'sari').toLocaleLowerCase('tr-TR'), label: c[0] };
    });
    var SORTS = rows('oSirala').map(function (c) {
      return { id: c[1] || slug(c[0]), label: c[0] };
    });
    if (!URUNS.length || !PRICE_BANDS_LIVE.length) return;

    /* grup basliklari da Customize'dan (data-t-*) */
    var bd = bd0;
    var GROUPS = {
      urun:     { defs:URUNS,            title:bd.tUrun || 'Ürün' },
      kategori: { defs:KATS,             title:bd.tKategori || 'Kategori' },
      fiyat:    { defs:PRICE_BANDS_LIVE, title:bd.tFiyat || 'Fiyat' },
      montur:   { defs:MONTURS,          title:bd.tMontur || 'Montür Rengi' } };

    var ORDER = ['urun', 'kategori', 'fiyat', 'montur'];

    var state = { urun:[], kategori:[], fiyat:[], montur:[], sirala:null };

    var cards = {};
    var PRODUCTS = [];
    Array.prototype.forEach.call(grid.querySelectorAll('.pcard[data-id]'), function (el) {
      cards[el.getAttribute('data-id')] = el;
      var p = parseCard(el);
      p.tags = (el.getAttribute('data-tags') || '').toLocaleLowerCase('tr-TR')
                 .split('|').map(function (t) { return t.trim(); }).filter(Boolean);
      p.montur = el.getAttribute('data-montur') || '';
      PRODUCTS.push(p);
      /* Karat sat\u0131r\u0131 art\u0131k Liquid taraf\u0131ndan (data-carat'tan) do\u011frudan
         yaz\u0131l\u0131yor \u2014 \u00e7oklu ta\u015fta "2,01 ct - 1,03 ct" gibi g\u00f6r\u00fcnmesi gerekiyor,
         JS'in tek bir toplam say\u0131ya indirgemesini istemiyoruz. Liquid hi\u00e7
         yazmad\u0131ysa (bo\u015fsa) eski y\u00f6ntemle JS doldurur \u2014 fail-open. */
      var kEl = el.querySelector('.pcard__carat');
      if (kEl && !kEl.textContent.trim() && p.karat != null) {
        kEl.textContent = p.karat.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ct';
      }
      /* Fiyat art\u0131k JS'de burada tek par\u00e7a d\u00fcz metne \u00e7evrilmiyor \u2014 eskiden
         .price eleman\u0131n\u0131n T\u00dcM i\u00e7eri\u011fini textContent ile eziyordu, bu da
         Liquid'in yazd\u0131\u011f\u0131 indirim yap\u0131s\u0131n\u0131 (<s> etiketini) her sayfa
         y\u00fcklemesinde siliyordu. Format art\u0131k dosyadaki genel [data-tl]
         d\u00f6n\u00fc\u015ft\u00fcr\u00fcc\u00fcs\u00fcne b\u0131rak\u0131l\u0131yor (her fiyat par\u00e7as\u0131 kendi data-tl'sini
         ta\u015f\u0131yor), yap\u0131ya dokunmadan sadece metni bi\u00e7imlendiriyor. */
    });

    function hasTag(p, t) { return p.tags.indexOf(t) > -1; }
    function katMatch(p, def) {
      if (!def.bare) return hasTag(p, def.tag);
      if (!hasTag(p, def.tag)) return false;
      return !KATS.some(function (k) {
        return k.parent === def.parent && !k.bare && hasTag(p, k.tag);
      });
    }
    function optMatch(p, g, id) {
      var def = GROUPS[g].defs.filter(function (x) { return x.id === id; })[0];
      if (!def) return false;
      if (g === 'urun')     return p.category === def.id || hasTag(p, def.tag);
      if (g === 'kategori') return katMatch(p, def);
      if (g === 'montur')   return p.montur.indexOf(def.id) > -1;
      if (g === 'fiyat')    return p.price != null && p.price >= def.min && p.price < def.max;
      return false;
    }
    function groupMatch(p, g, sel) {
      if (!sel.length) return true;
      return sel.some(function (id) { return optMatch(p, g, id); });
    }
    function fullMatch(p, override) {
      return ORDER.every(function (g) {
        var sel = override && g === override.g ? override.sel : state[g];
        return groupMatch(p, g, sel);
      });
    }
    function facetCount(g, id) {   // this option + every OTHER group's selection
      return PRODUCTS.filter(function (p) {
        return fullMatch(p, { g:g, sel:[id] });
      }).length;
    }
    function matches() { return PRODUCTS.filter(function (p) { return fullMatch(p, null); }); }

    /* Kategori, ürüne bağlı: ürün seçiliyse yalnızca onun kategorileri. */
    function visibleKats() {
      if (!state.urun.length) return KATS;
      return KATS.filter(function (k) { return state.urun.indexOf(k.parent) > -1; });
    }

    function sorted(list) {
      if (!state.sirala) return list;               // catalogue order, unsorted
      var out = list.slice();
      var nullsLast = function (v) { return v == null ? Infinity : v; };
      if (state.sirala === 'karat-azalan')
        out.sort(function (a, b) { return (b.karat == null ? -Infinity : b.karat) - (a.karat == null ? -Infinity : a.karat); });
      if (state.sirala === 'karat-artan')
        out.sort(function (a, b) { return nullsLast(a.karat) - nullsLast(b.karat); });
      if (state.sirala === 'fiyat-artan')
        out.sort(function (a, b) { return nullsLast(a.price) - nullsLast(b.price); });
      if (state.sirala === 'fiyat-azalan')
        out.sort(function (a, b) { return (b.price == null ? -Infinity : b.price) - (a.price == null ? -Infinity : a.price); });
      return out;
    }

    /* ---------- URL state (replaceState — back leaves the page) ---------- */
    function writeURL() {
      var q = [];
      ORDER.forEach(function (g) {
        if (state[g].length) q.push(g + '=' + state[g].join(','));
      });
      if (state.sirala) q.push('sirala=' + state.sirala);
      var url = location.pathname + (q.length ? '?' + q.join('&') : '') + location.hash;
      try { history.replaceState(null, '', url); } catch (e) {}
    }
    function readURL() {
      var sp = new URLSearchParams(location.search);
      ORDER.forEach(function (g) {
        var v = sp.get(g);
        if (!v) return;
        var valid = GROUPS[g].defs.map(function (d) { return d.id; });
        state[g] = v.split(',').filter(function (x) { return valid.indexOf(x) > -1; });
      });
      var so = sp.get('sirala');
      if (so && SORTS.some(function (x) { return x.id === so; })) state.sirala = so;
    }

    /* ---------- option rows (shared by sidebar and the sheet) ---------- */
    function makeRow(g, def) {
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'frow';
      row.setAttribute('role', 'checkbox');
      row.setAttribute('data-opt', def.id);
      row.setAttribute('aria-checked', String(state[g].indexOf(def.id) > -1));

      var box = document.createElement('span');
      box.className = 'frow__box';
      box.innerHTML = '<svg class="frow__tick" viewBox="0 0 10 10" aria-hidden="true"><path d="M1.5 5.5l2.5 2.5 4.5-5.5"/></svg>';
      row.appendChild(box);

      if (g === 'montur') {                     // renk pulu
        var sw = document.createElement('span');
        sw.className = 'frow__swatch';
        sw.style.background = def.id === 'sari' ? '#C9A227' : '#D8D8D8';
        row.appendChild(sw);
      }

      var lab = document.createElement('span');
      lab.className = 'frow__label';
      lab.textContent = def.label;
      row.appendChild(lab);

      var cnt = document.createElement('span');
      cnt.className = 'frow__count';
      row.appendChild(cnt);

      row.addEventListener('click', function () {
        if (row.disabled) return;
        var i = state[g].indexOf(def.id);
        if (i > -1) state[g].splice(i, 1); else state[g].push(def.id);
        if (g === 'urun') {                     // gizlenen kategorileri bırak
          var vis = visibleKats().map(function (k) { return k.id; });
          state.kategori = state.kategori.filter(function (id) { return vis.indexOf(id) > -1; });
        }
        apply();
      });
      return row;
    }
    function refreshRows(scope) {
      ORDER.forEach(function (g) {
        Array.prototype.forEach.call(scope.querySelectorAll('[data-fg="' + g + '"] .frow'), function (row) {
          var id = row.getAttribute('data-opt');
          var n = facetCount(g, id);
          row.querySelector('.frow__count').textContent = n;
          row.setAttribute('aria-checked', String(state[g].indexOf(id) > -1));
          row.disabled = n === 0 && state[g].indexOf(id) === -1;   // dimmed, never hidden
        });
      });
    }

    /* ---------- accordion groups (sidebar + sheet share the builder) ---------- */
    function buildGroups(container, openMap) {
      container.innerHTML = '';
      ORDER.forEach(function (g) {
        var wrap = document.createElement('div');
        wrap.className = 'fsec';
        wrap.setAttribute('data-fg', g);
        var head = document.createElement('button');
        head.type = 'button'; head.className = 'fsec__btn';
        head.setAttribute('aria-expanded', String(!!openMap[g]));
        head.innerHTML = '<span></span><i class="fsec__plus" aria-hidden="true"></i>';
        head.querySelector('span').textContent = GROUPS[g].title;
        var opts = document.createElement('div');
        opts.className = 'fsec__opts';
        opts.hidden = !openMap[g];
        var defs = g === 'kategori' ? visibleKats() : GROUPS[g].defs;
        defs.forEach(function (def) { opts.appendChild(makeRow(g, def)); });
        head.addEventListener('click', function () {
          openMap[g] = opts.hidden;
          opts.hidden = !opts.hidden;
          head.setAttribute('aria-expanded', String(openMap[g]));
        });
        wrap.appendChild(head); wrap.appendChild(opts);
        container.appendChild(wrap);
      });
      refreshRows(container);
    }

    var sideOpen = { urun:false, kategori:false, fiyat:false, montur:false };   // lululemon: hepsi kapalı başlar
    var lastKatKey = '';
    function refreshSide() {
      var key = state.urun.slice().sort().join(',');
      if (key !== lastKatKey) {          // ürün değişti → kategori listesi değişir
        lastKatKey = key;
        buildGroups(side, sideOpen);
      } else {
        refreshRows(side);
      }
    }

    /* ---------- toolbar: gizle/göster + sırala ---------- */
    /* lululemon davranışı: kapalı başlar; butona hover sütunu ÖNİZLETİR,
       imleç buton+sütun bölgesinden çıkınca geri saklanır. Kalıcılık için
       tık gerekir; önizlemedeyken bir filtreye dokunmak da sabitler. */
    var flx = document.querySelector('[data-flx]');
    var toggleBtn = document.querySelector('[data-flx-toggle]');
    var toggleLab = document.querySelector('[data-flx-toggle-label]');
    var pinned = false;
    var hoverable = window.matchMedia('(hover:hover) and (min-width:901px)').matches;
    var hideTimer = null;

    function setOpen(open) { if (flx) flx.classList.toggle('is-closed', !open); }
    function updateToggle() {
      if (!toggleBtn) return;
      toggleBtn.setAttribute('aria-expanded', String(pinned));
      toggleLab.textContent = pinned
        ? (toggleLab.getAttribute('data-hide') || 'Filtreleri gizle')
        : (toggleLab.getAttribute('data-show') || 'Filtreleri göster');
    }
    function pin(open) { pinned = open; setOpen(open); updateToggle(); }
    function holdOpen() {
      if (pinned) return;
      if (hideTimer) { window.clearTimeout(hideTimer); hideTimer = null; }
      setOpen(true);
    }
    function letGo() {
      if (pinned) return;
      if (hideTimer) window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () { if (!pinned) setOpen(false); }, 260);
    }
    if (toggleBtn && flx) {
      toggleBtn.addEventListener('click', function () { pin(!pinned); });
      if (hoverable) {
        toggleBtn.addEventListener('mouseenter', holdOpen);
        toggleBtn.addEventListener('mouseleave', letGo);
        side.addEventListener('mouseenter', holdOpen);
        side.addEventListener('mouseleave', letGo);
        side.addEventListener('click', function () {       // önizlemede seçim = sabitle
          if (!pinned) pin(true);
        });
      }
      updateToggle();
    }

    /* kategori kartları (Kolye/Küpe/Yüzük) → Ürün filtresi, sayfa yenilenmeden */
    Array.prototype.forEach.call(document.querySelectorAll('.cats--mini .cat'), function (tile) {
      tile.addEventListener('click', function (e) {
        var m = (tile.getAttribute('href') || '').match(/[?&]urun=([a-z]+)/);
        if (!m) return;
        var id = m[1];
        if (!URUNS.some(function (u) { return u.id === id; })) return;
        e.preventDefault();
        state.urun = [id];
        sideOpen.urun = true;
        var vis = visibleKats().map(function (k) { return k.id; });
        state.kategori = state.kategori.filter(function (x) { return vis.indexOf(x) > -1; });
        apply();
        var bar = document.querySelector('[data-flx-bar]');
        if (bar) {
          var navH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-h'), 10) || 64;
          window.scrollTo({ top: window.pageYOffset + bar.getBoundingClientRect().top - navH - 12, behavior: 'smooth' });
        }
      });
    });

    var sortWrap = document.querySelector('[data-flx-sort]');
    var sortBtn = document.querySelector('[data-flx-sortbtn]');
    var sortMenu = document.querySelector('[data-flx-sortmenu]');
    var sortLab = document.querySelector('[data-flx-sortlabel]');
    var featuredLbl = (sortLab && sortLab.getAttribute('data-featured')) || 'Öne çıkanlar';
    function sortLabel() {
      if (!state.sirala) return featuredLbl;
      return SORTS.filter(function (x) { return x.id === state.sirala; })[0].label;
    }
    function buildSortMenu() {
      sortMenu.innerHTML = '';
      [{ id:null, label:featuredLbl }].concat(SORTS).forEach(function (def) {
        var r = document.createElement('button');
        r.type = 'button'; r.className = 'frow';
        r.setAttribute('role', 'radio');
        r.setAttribute('aria-checked', String(state.sirala === def.id));
        r.innerHTML = '<span class="frow__label"></span>';
        r.querySelector('.frow__label').textContent = def.label;
        r.addEventListener('click', function () {
          state.sirala = def.id;
          closeSort();
          apply();
        });
        sortMenu.appendChild(r);
      });
    }
    function closeSort() {
      sortMenu.hidden = true;
      sortBtn.setAttribute('aria-expanded', 'false');
    }
    if (sortBtn) {
      sortBtn.addEventListener('click', function () {
        if (sortMenu.hidden) {
          buildSortMenu();
          sortMenu.hidden = false;
          sortBtn.setAttribute('aria-expanded', 'true');
        } else closeSort();
      });
      document.addEventListener('click', function (e) {
        if (!sortMenu.hidden && !sortWrap.contains(e.target)) closeSort();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !sortMenu.hidden) closeSort();
      });
    }

    /* ---------- mobile sheet ---------- */
    var sheet = document.querySelector('[data-fsheet]');
    var sheetBody = document.querySelector('[data-fsheet-body]');
    var mobBtn = document.querySelector('[data-fmobile]');
    var lastFocus = null;

    function openSheet() {
      lastFocus = document.activeElement;
      buildGroups(sheetBody, {});
      updateSheetFoot();
      sheet.hidden = false;
      document.documentElement.classList.add('is-locked');
      // setTimeout, not rAF: rAF never fires in throttled/background tabs,
      // which would leave the sheet functional but invisible
      window.setTimeout(function () { sheet.classList.add('is-open'); }, 20);
      var f = sheet.querySelector('button');
      if (f) f.focus();
    }
    function closeSheet() {
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('is-locked');
      window.setTimeout(function () { sheet.hidden = true; }, 420);
      if (lastFocus) lastFocus.focus();
    }
    function updateSheetFoot() {
      var n = matches().length;
      var show = sheet.querySelector('[data-fsheet-show]');
      if (show) show.textContent = (show.getAttribute('data-base') || 'Göster') + ' (' + n + ')';
    }
    if (mobBtn && sheet) {
      mobBtn.addEventListener('click', openSheet);
      sheet.querySelector('[data-fsheet-close]').addEventListener('click', closeSheet);
      sheet.querySelector('[data-fsheet-show]').addEventListener('click', closeSheet);
      sheet.querySelector('[data-fsheet-clear]').addEventListener('click', function () {
        ORDER.forEach(function (g) { state[g] = []; });
        apply();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !sheet.hidden) closeSheet();
      });
      sheet.addEventListener('keydown', function (e) {     // focus trap
        if (e.key !== 'Tab') return;
        var f = sheet.querySelectorAll('button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    /* ---------- chips ---------- */
    var chipsEl = document.querySelector('[data-chips]');
    function labelFor(g, id) {
      var d = GROUPS[g].defs.filter(function (x) { return x.id === id; })[0];
      return d ? d.label : id;
    }
    function renderChips() {
      chipsEl.innerHTML = '';
      var total = 0;
      ORDER.forEach(function (g) {
        state[g].forEach(function (id) {
          total++;
          var c = document.createElement('button');
          c.type = 'button'; c.className = 'chip-f';
          c.innerHTML = '<span></span><svg viewBox="0 0 10 10" aria-hidden="true"><path d="M1.5 1.5l7 7M8.5 1.5l-7 7"/></svg>';
          c.querySelector('span').textContent = labelFor(g, id);
          c.setAttribute('aria-label', labelFor(g, id) + ' filtresini kaldır');
          c.addEventListener('click', function () {
            state[g] = state[g].filter(function (x) { return x !== id; });
            apply();
          });
          chipsEl.appendChild(c);
        });
      });
      if (total >= 2) {
        var all = document.createElement('button');
        all.type = 'button'; all.className = 'chips__clear';
        all.textContent = chipsEl.getAttribute('data-clear-all') || 'Tümünü temizle';
        all.addEventListener('click', function () {
          ORDER.forEach(function (g) { state[g] = []; });
          apply();
        });
        chipsEl.appendChild(all);
      }
      return total;
    }

    /* ---------- grid update with quiet motion ---------- */
    var fcount = document.querySelector('[data-fcount]');
    var fempty = document.querySelector('[data-fempty]');
    var emptyClear = document.querySelector('[data-fempty-clear]');
    if (emptyClear) emptyClear.addEventListener('click', function (e) {
      e.preventDefault();
      ORDER.forEach(function (g) { state[g] = []; });
      apply();
    });

    var reducedNow = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function updateGrid() {
      var list = sorted(matches());
      var visibleIds = list.map(function (p) { return p.id; });
      var entering = [], leaving = [];
      Object.keys(cards).forEach(function (id) {
        var el = cards[id];
        var willShow = visibleIds.indexOf(id) > -1;
        if (willShow && el.hidden) entering.push(el);
        if (!willShow && !el.hidden) leaving.push(el);
      });

      function settle() {
        /* FLIP the survivors so the reflow reads as movement, not a jump */
        var staying = visibleIds.map(function (id) { return cards[id]; })
                                .filter(function (el) { return !el.hidden; });
        var before = {};
        staying.forEach(function (el) { before[el.getAttribute('data-id')] = el.getBoundingClientRect(); });

        leaving.forEach(function (el) { el.hidden = true; el.classList.remove('f-out'); });
        visibleIds.forEach(function (id) { grid.appendChild(cards[id]); });   // sort order
        entering.forEach(function (el) { el.hidden = false; el.classList.add('f-in'); el.classList.add('is-in'); });

        if (!reducedNow) {
          staying.forEach(function (el) {
            var b = before[el.getAttribute('data-id')];
            if (!b) return;
            var a = el.getBoundingClientRect();
            var dx = b.left - a.left, dy = b.top - a.top;
            if (!dx && !dy) return;
            el.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
            el.getBoundingClientRect();
            el.classList.add('f-flip');
            el.style.transform = '';
            window.setTimeout(function () { el.classList.remove('f-flip'); }, 320);
          });
          entering.forEach(function (el, i) {
            var step = Math.min(i, 7);                    // stagger capped at 8 steps
            el.style.transitionDelay = (step * 40) + 'ms';
            el.getBoundingClientRect();
            el.classList.add('f-in-go');
            window.setTimeout(function () {
              el.classList.remove('f-in', 'f-in-go');
              el.style.transitionDelay = '';
            }, 700);
          });
        } else {
          entering.forEach(function (el) { el.classList.remove('f-in'); });
        }

        fcount.textContent = list.length + ' ' + (fcount.getAttribute('data-suffix') || 'ürün');
        fempty.hidden = list.length !== 0;
        grid.style.display = list.length === 0 ? 'none' : '';
      }

      if (leaving.length && !reducedNow) {
        leaving.forEach(function (el) { el.classList.add('f-out'); });
        window.setTimeout(settle, 200);
      } else {
        settle();
      }
    }

    function refreshLabels() {
      if (sortLab) sortLab.textContent = sortLabel();
      var mLab = document.querySelector('[data-fmobile-label]');
      if (mLab) {
        var total = ORDER.reduce(function (a, g) { return a + state[g].length; }, 0);
        mLab.textContent = (mLab.getAttribute('data-base') || 'Filtrele') + (total ? ' (' + total + ')' : '');
      }
    }

    function apply() {
      updateGrid();
      renderChips();
      refreshSide();
      refreshLabels();
      writeURL();
      if (sheet && !sheet.hidden) { refreshRows(sheetBody); updateSheetFoot(); }
    }

    readURL();
    ORDER.forEach(function (g) { if (state[g].length) sideOpen[g] = true; });   // URL'den gelen seçim görünür olsun
    buildGroups(side, sideOpen);
    lastKatKey = state.urun.slice().sort().join(',');
    apply();

    /* Sayfa bir filtreyle (kategori kartından tıklanarak ya da doğrudan
       linkle) geldiyse, ziyaretçi en üstte kalıp aşağıda sonuçların
       değiştiğini fark etmeyebilir — kısa bir gecikmeyle ızgaraya doğru
       hafifçe kaydırıyoruz. Filtre yoksa hiçbir şey olmaz. */
    var hasIncomingFilter = ORDER.some(function (g) { return state[g].length > 0; });
    var wantsGridScroll = window.location.hash === '#grid';
    if (hasIncomingFilter || wantsGridScroll) {
      window.setTimeout(function () {
        var bar = document.querySelector('[data-flx-bar]');
        if (!bar) return;
        var navH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-h'), 10) || 64;
        var y = window.pageYOffset + bar.getBoundingClientRect().top - navH - 12;
        try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); }
      }, 350);
    }
  })();

  /* --------------------------------------------------------
     RANDEVU — the form composes a WhatsApp message.
     If {{WHATSAPP_NO}} is still a token, fall back to showing
     the composed message for manual sending — never a dead end.
     -------------------------------------------------------- */
  (function randevu() {
    var root = document.querySelector('[data-rdv]');
    if (!root || root.hasAttribute('data-posted')) return;
    var form = root.querySelector('form');
    if (!form) return;
    var NO = (root.getAttribute('data-wa') || '').replace(/\D/g, '');

    /* ---------- the note: every answer writes a line ---------- */
    var lines = {};
    Array.prototype.forEach.call(form.querySelectorAll('[data-rdv-slot]'), function (el) {
      lines[el.getAttribute('data-rdv-slot')] = el;
    });
    function write(slot, value) {
      var line = lines[slot];
      if (!line) return;
      var dd = line.querySelector('dd');
      if (dd.textContent === value) return;
      dd.textContent = value;
      line.classList.toggle('is-set', !!value);
      if (value) {
        dd.style.animation = 'none';
        dd.getBoundingClientRect();
        dd.style.animation = '';
      }
    }

    function val(name) {
      var el = form.querySelector('input[name="' + name + '"]:checked') ||
               form.querySelector('input[type="hidden"][name="' + name + '"]');
      return el ? el.value : '';
    }
    function labelOf(slot) {
      var line = lines[slot];
      var dt = line && line.querySelector('dt');
      return dt ? dt.textContent.trim() : slot;
    }
    var adEl = form.querySelector('#r-ad');
    var telEl = form.querySelector('#r-tel');
    var emailEl = form.querySelector('#r-email');
    var notEl2 = form.querySelector('#r-not');
    var emailField = form.querySelector('[data-rdv-emailfield]');
    var bodyEl = form.querySelector('[data-rdv-body]');
    var errEl = form.querySelector('[data-rdv-err]');

    function compose() {
      var parts = ['Merhaba, randevu almak istiyorum.'];
      ['kim', 'ilgi', 'bulusma', 'zaman'].forEach(function (k) {
        if (k === 'zaman' && !needsTime()) return;
        var v = val(k);
        if (v) parts.push('\u2022 ' + labelOf(k) + ': ' + v);
      });
      if (adEl && adEl.value.trim()) parts.push('\u2022 Ad: ' + adEl.value.trim());
      if (telEl && telEl.value.trim()) parts.push('\u2022 Telefon: ' + telEl.value.trim());
      if (emailEl && emailEl.value.trim() && !(emailField && emailField.hidden)) parts.push('\u2022 E-posta: ' + emailEl.value.trim());
      if (notEl2 && notEl2.value.trim()) parts.push('\u2022 Not: ' + notEl2.value.trim());
      return parts.join('\n');
    }

    function showErr(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }
    function clearErr() { if (errEl) { errEl.hidden = true; errEl.textContent = ''; } }

    function isWhatsChoice() { return /whatsapp/i.test(val('bulusma')); }

    /* buluşma seçeneğinin türü — metin Customize'dan değişebilir */
    function kindOf(v) {
      if (/whats\s*app/i.test(v)) return 'whatsapp';
      if (/g[oö]r[uü]nt[uü]/i.test(v)) return 'goruntulu';
      if (/ma[gğ]aza/i.test(v)) return 'magaza';
      return v ? 'diger' : '';
    }
    /* Zaman (takvim) yalnız mağaza randevusunda sorulur */
    function needsTime() {
      var k = kindOf(val('bulusma'));
      return k === '' || k === 'magaza';
    }

    /* WhatsApp meeting: only the phone is asked; otherwise both fields
       stand and at least one is required at submit. */
    var contactNote = form.querySelector('.rdv__contactnote');
    function updateContactMode() {
      // WhatsApp'ta telefon zaten zorunlu — teşvik notu gereksiz
      if (contactNote) contactNote.hidden = isWhatsChoice();
      if (!emailField) return;
      emailField.hidden = isWhatsChoice();
    }

    /* The send button is type="button" and everything runs from this
       click handler: Shopify's spam-protection script hijacks any
       'submit' event on a contact form (it bounces the browser to
       /challenge even when the event is preventDefault-ed), which
       would yank WhatsApp users and validation errors off the page.
       Only the genuine e-posta path talks to the server — via
       form.submit(), which fires no 'submit' event. */
    /* Gönder (2026-10-06): HER tamamlanan form mağazaya gider — e-posta,
       yalnız telefon ya da WhatsApp seçimi fark etmez (eski "kopyalayıp
       WhatsApp'tan gönderin" kutusu kaldırıldı). Shopify iletişim formu
       e-posta ister: ziyaretçi e-posta bırakmadıysa mağazanın kendi adresi
       gizli alanla gönderilir, nota "e-posta bırakılmadı" satırı eklenir
       (yanıtla → mağazaya döner, kimseye gitmez). Telefon / e-posta biçimi
       göndermeden önce kontrol edilir — Shopify hatası sayfayı yeniler ve
       cevapları silerdi. Çift dokunma tek gönderim. */
    var sending = false;
    function resetSend() {
      sending = false;
      root.classList.remove('is-sending');
      if (sendBtn) { sendBtn.disabled = false; sendBtn.removeAttribute('aria-busy'); }
      Array.prototype.forEach.call(form.querySelectorAll('[data-rdv-ghost]'), function (g) { g.parentNode.removeChild(g); });
      if (emailEl) emailEl.disabled = false;
    }
    function trySend() {
      if (sending) return;
      clearErr();
      var phone = telEl ? telEl.value.trim() : '';
      var email = emailEl && emailField && !emailField.hidden ? emailEl.value.trim() : '';

      if (isWhatsChoice() && !phone) {
        showErr(root.getAttribute('data-err-phone') || 'Telefon numaranız gerekli.');
        if (telEl) telEl.focus();
        return;
      }
      if (!isWhatsChoice() && !phone && !email) {
        showErr(root.getAttribute('data-err-contact') || 'Telefon ya da e-posta bırakmanız yeterli.');
        if (telEl) telEl.focus();
        return;
      }
      var digits = phone.replace(/[^0-9]/g, '');
      if (phone && (digits.length < 10 || digits.length > 15)) {
        showErr(root.getAttribute('data-err-phonefmt') || 'Telefon numaranızı kontrol edin.');
        if (telEl) telEl.focus();
        return;
      }
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        showErr(root.getAttribute('data-err-form') || 'E-posta adresinizi kontrol edin.');
        if (emailEl) emailEl.focus();
        return;
      }

      var msg = compose();
      if (!email) msg += '\n\u2022 E-posta: bırakılmadı — lütfen telefonla dönüş yapın.';
      if (bodyEl) bodyEl.value = msg;

      if (!email) {
        if (emailEl) emailEl.disabled = true;
        var ghost = document.createElement('input');
        ghost.type = 'hidden';
        ghost.name = 'contact[email]';
        ghost.value = root.getAttribute('data-noemail') || 'info@finebymers.com';
        ghost.setAttribute('data-rdv-ghost', '');
        form.appendChild(ghost);
      }

      // Meta "Lead": tek kullanımlık kimlik; başarı sayfasında (contact_posted=true)
      // snippets/meta-events.liquid bir kez yayınlar ve siler.
      try {
        window.sessionStorage.setItem('fine_rdv_eid',
          'rdv_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10));
      } catch (e) {}

      sending = true;
      root.classList.add('is-sending');
      if (sendBtn) { sendBtn.disabled = true; sendBtn.setAttribute('aria-busy', 'true'); }
      window.setTimeout(resetSend, 15000);   // ağ takılırsa düğme geri gelsin
      form.submit();   // Shopify notu mağazaya e-postalar → ?contact_posted=true
    }

    var sendBtn = form.querySelector('[data-rdv-submit]');
    if (sendBtn) sendBtn.addEventListener('click', trySend);
    // geri tuşuyla dönülürse (bfcache) form yeniden kullanılabilir olsun
    window.addEventListener('pageshow', resetSend);

    /* Enter in a text field must route through trySend too — an
       implicit submission would fire the 'submit' event Shopify hijacks. */
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.target.tagName === 'TEXTAREA') return;
      e.preventDefault();
      if (e.target.type === 'text' || e.target.type === 'tel' || e.target.type === 'email') trySend();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); trySend(); });

    if (adEl) adEl.addEventListener('input', function () { write('ad', adEl.value.trim()); });
    if (telEl) telEl.addEventListener('input', function () { write('tel', telEl.value.trim()); });
    if (notEl2) notEl2.addEventListener('input', function () { write('not', notEl2.value.trim()); });

    /* ---------- one question at a time ---------- */
    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-rdv-step]'));
    var bar = form.querySelector('[data-rdv-bar]');
    if (!steps.length) return;

    var at = -1;
    var noteEl = root.querySelector('[data-rdv-note]');
    var stage = root.querySelector('.rdv__stage');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function slotOf(st) { return st.getAttribute('data-rdv-step'); }
    function markComplete() { if (noteEl) noteEl.classList.toggle('is-complete', answered()); }

    /* ---------- zaman: takvim — solda gün, sağda saatler ---------- */
    function h(tag, cls, text) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text != null) e.textContent = text;
      return e;
    }
    function buildCal(el, onPick) {
      var MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz',
                    'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
      var DAYS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
      var SHORT = ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'];
      var input = el.querySelector('input[name="zaman"]');
      if (!input) return null;
      var fb = el.querySelector('[data-rdv-calfallback]');
      input.type = 'hidden';
      input.value = '';
      el.appendChild(input);
      if (fb) fb.parentNode.removeChild(fb);

      var closed = (el.getAttribute('data-closed') || '').split(',').map(function (s) {
        return s.trim().toLocaleLowerCase('tr');
      });
      var slots = (el.getAttribute('data-slots') || '').split(',').map(function (s) {
        return s.trim().replace('.', ':');
      }).filter(function (s) { return /^\d{1,2}:\d{2}$/.test(s); });
      var ahead = parseInt(el.getAttribute('data-ahead'), 10) || 60;
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var last = new Date(today); last.setDate(last.getDate() + ahead);
      var firstMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      var view = firstMonth;
      var picked = null, pickedTime = '';

      function mins(s) { var p = s.split(':'); return (+p[0]) * 60 + (+p[1]); }
      function freeSlots(d) {
        if (d.getTime() !== today.getTime()) return slots;
        var now = new Date();
        var cut = now.getHours() * 60 + now.getMinutes() + 60;   // bugün: en az 1 saat sonrası
        return slots.filter(function (s) { return mins(s) >= cut; });
      }
      function isOpen(d) {
        return d >= today && d <= last &&
          closed.indexOf(DAYS[d.getDay()].toLocaleLowerCase('tr')) < 0 &&
          freeSlots(d).length > 0;
      }
      function dateText(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + DAYS[d.getDay()]; }

      var wrap = h('div', 'rdv__calgrid');
      var mon = h('div', 'rdv__calmonth');
      var head = h('div', 'rdv__calhead');
      var prev = h('button', 'rdv__calnav', '‹');
      var name = h('span', 'rdv__calname');
      var next = h('button', 'rdv__calnav', '›');
      prev.type = next.type = 'button';
      prev.setAttribute('aria-label', 'Önceki ay');
      next.setAttribute('aria-label', 'Sonraki ay');
      head.appendChild(prev); head.appendChild(name); head.appendChild(next);
      var week = h('div', 'rdv__calweek');
      SHORT.forEach(function (s) { week.appendChild(h('span', '', s)); });
      var grid = h('div', 'rdv__caldays');
      mon.appendChild(head); mon.appendChild(week); mon.appendChild(grid);

      var side = h('div', 'rdv__caltimes');
      side.appendChild(h('p', 'label rdv__caltimeshead', el.getAttribute('data-times-label') || 'Uygun saatler'));
      var sideDate = h('p', 'rdv__caldate');
      var hint = h('p', 'rdv__calhint', el.getAttribute('data-pick-label') || 'Soldan size uygun bir gün seçin.');
      var list = h('div', 'rdv__slots');
      side.appendChild(sideDate); side.appendChild(hint); side.appendChild(list);
      wrap.appendChild(mon); wrap.appendChild(side);
      el.insertBefore(wrap, input);

      function renderMonth() {
        name.textContent = MONTHS[view.getMonth()] + ' ' + view.getFullYear();
        prev.disabled = view <= firstMonth;
        next.disabled = new Date(view.getFullYear(), view.getMonth() + 1, 1) > last;
        grid.innerHTML = '';
        var lead = (view.getDay() + 6) % 7;            // hafta pazartesi başlar
        for (var k = 0; k < lead; k++) grid.appendChild(h('span', 'rdv__calpad'));
        var dim = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
        for (var n = 1; n <= dim; n++) {
          (function (d) {
            var b = h('button', 'rdv__calday', String(d.getDate()));
            b.type = 'button';
            b.setAttribute('aria-label', dateText(d));
            if (!isOpen(d)) b.disabled = true;
            if (d.getTime() === today.getTime()) b.classList.add('is-today');
            if (picked && d.getTime() === picked.getTime()) {
              b.classList.add('is-picked');
              b.setAttribute('aria-pressed', 'true');
            }
            b.addEventListener('click', function () {
              picked = d; pickedTime = ''; input.value = '';
              renderMonth(); renderTimes();
            });
            grid.appendChild(b);
          })(new Date(view.getFullYear(), view.getMonth(), n));
        }
      }
      function renderTimes() {
        list.innerHTML = '';
        hint.hidden = !!picked;
        sideDate.hidden = !picked;
        sideDate.textContent = picked ? dateText(picked) : '';
        if (!picked) return;
        freeSlots(picked).forEach(function (s) {
          var b = h('button', 'rdv__slot', s);
          b.type = 'button';
          if (s === pickedTime) b.classList.add('is-picked');
          b.addEventListener('click', function () {
            pickedTime = s;
            input.value = dateText(picked) + ' · ' + s;
            Array.prototype.forEach.call(list.children, function (x) {
              x.classList.toggle('is-picked', x === b);
            });
            onPick(input.value);
          });
          list.appendChild(b);
        });
      }
      prev.addEventListener('click', function () {
        view = new Date(view.getFullYear(), view.getMonth() - 1, 1); renderMonth();
      });
      next.addEventListener('click', function () {
        view = new Date(view.getFullYear(), view.getMonth() + 1, 1); renderMonth();
      });
      renderMonth(); renderTimes();
      return {
        reset: function () { picked = null; pickedTime = ''; input.value = ''; renderMonth(); renderTimes(); }
      };
    }

    var cal = null;
    var calEl = form.querySelector('[data-rdv-cal]');
    if (calEl) {
      cal = buildCal(calEl, function (text) {
        write('zaman', text);
        markComplete();
        var i = steps.indexOf(calEl.closest('[data-rdv-step]'));
        window.setTimeout(function () { var n = nextFrom(i); if (n !== i) show(n, true); }, 520);
      });
    }

    /* ---------- hangi adımlar soruluyor ----------
       Buluşma şekli linkten gelebilir (?bulusma=magaza|goruntulu|whatsapp —
       ana sayfadaki Özel Danışmanlık listesi): o zaman soru sorulmaz, seçenek
       işaretli gelir, form doğrudan açılır. Zaman yalnız Mağazada sorulur. */
    var presetDone = false;
    var presetKey = (window.location.search.match(/[?&]bulusma=([^&#]+)/) || [])[1] || '';
    try { presetKey = decodeURIComponent(presetKey).toLowerCase(); } catch (e) { presetKey = ''; }
    if (presetKey) {
      Array.prototype.some.call(form.querySelectorAll('input[name="bulusma"]'), function (r) {
        if (kindOf(r.value) !== presetKey) return false;
        r.checked = true;
        write('bulusma', r.value);
        presetDone = true;
        return true;
      });
    }

    function active(st) {
      var s = slotOf(st);
      if (s === 'bulusma' && presetDone) return false;
      if (s === 'zaman' && !needsTime()) return false;
      return true;
    }
    function nextFrom(i) {
      for (var j = i + 1; j < steps.length; j++) if (active(steps[j])) return j;
      return i;
    }
    function prevFrom(i) {
      for (var j = i - 1; j >= 0; j--) if (active(steps[j])) return j;
      return i;
    }
    function answered() {
      return steps.every(function (st) {
        var s = slotOf(st);
        if (s === 'son') return true;
        if (s !== 'bulusma' && !active(st)) return true;
        return !!val(s);
      });
    }
    function syncTime() {
      var need = needsTime();
      if (lines.zaman) lines.zaman.classList.toggle('is-off', !need);
      if (!need && val('zaman')) {
        if (cal) cal.reset();
        write('zaman', '');
      }
      markComplete();
    }
    syncTime();

    function park(instant) {
      if (!stage) return;
      var navH = parseInt(getComputedStyle(document.documentElement)
                  .getPropertyValue('--nav-h'), 10) || 76;
      var y = window.pageYOffset + stage.getBoundingClientRect().top - navH - 44;
      y = Math.max(0, Math.round(y));
      if (Math.abs(y - window.pageYOffset) < 4) return;
      if (instant || reduced) { window.scrollTo(0, y); return; }
      try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, y); }
    }

    function focusStep() {
      var st = steps[at];
      if (!st) return;
      st.setAttribute('tabindex', '-1');
      try { st.focus({ preventScroll: true }); } catch (err) { st.focus(); }
    }

    function show(i, focus, skipPark) {
      i = Math.max(0, Math.min(i, steps.length - 1));
      if (!active(steps[i])) {
        var n = nextFrom(i);
        i = n !== i ? n : prevFrom(i);
      }
      at = i;
      steps.forEach(function (st, k) { st.classList.toggle('is-on', k === at); });
      var live = steps.filter(active);
      if (bar) bar.style.width = Math.round(((live.indexOf(steps[at]) + 1) / live.length) * 100) + '%';
      Object.keys(lines).forEach(function (k) { lines[k].classList.remove('is-current'); });
      var slot = slotOf(steps[at]);
      if (lines[slot]) lines[slot].classList.add('is-current');
      if (slot === 'son') updateContactMode();
      if (!skipPark) park();
      if (focus) focusStep();
    }

    /* Başlayalım kartların ALTINDA: form düğmeye kadar gizli;
       tıklayınca kâğıt yükselerek gelir ve sayfa forma süzülür. */
    var begin = root.querySelector('[data-rdv-begin]');
    root.classList.add('is-live', 'is-idle');
    root.setAttribute('data-rdv-ready', '');
    if (begin) {
      begin.hidden = false;
      begin.querySelector('[data-rdv-start]').addEventListener('click', function () {
        begin.hidden = true;
        root.classList.remove('is-idle');
        root.classList.add('is-paper', 'is-open');
        show(0, false, true);
        park();
        window.setTimeout(function () { root.classList.remove('is-paper'); }, 1700);
        window.setTimeout(function () { focusStep(); }, reduced ? 0 : 900);
      });
      /* #rdv-form ile ya da buluşma şekli seçili gelindiyse Başlayalım'a
         tıklanmış gibi formu otomatik aç — ziyaretçi doğrudan notla başlar. */
      /* Reklamdan gelen ziyaretçi: Meta/Instagram linke fbclid (ve varsa utm_)
         ekler → düz /pages/randevu linki de doğrudan nota açılır. Menüden
         gelen normal ziyaretçi açılış ekranını görmeye devam eder. */
      var fromAd = /[?&](fbclid|gclid|ttclid|utm_source|utm_medium|utm_campaign)=/i.test(window.location.search);
      if (window.location.hash === '#rdv-form' || presetDone || fromAd) {
        root.classList.add('is-instant');   /* otomatik açılış: kayma/solma yok */
        window.setTimeout(function () { root.classList.remove('is-instant'); }, 2000);
        begin.querySelector('[data-rdv-start]').click();
        /* Reklamdan / bağlantıdan gelen ziyaretçi doğrudan notu görsün.
           Telefonda görseller ve yazı tipleri yüklendikçe sayfa uzuyor;
           ilk kaydırma erken kalıyordu (sayfa en üstte açılıyordu). Sayfa
           yerleşene kadar ilk soruya ANINDA kaydır; ziyaretçi kendisi
           kaydırdığı an bırak. (2026-10-05) */
        var rdvUserMoved = false;
        ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
          window.addEventListener(ev, function () { rdvUserMoved = true; }, { once: true, passive: true });
        });
        var rdvJump = function () { if (!rdvUserMoved) park(true); };
        try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
        rdvJump();
        window.addEventListener('load', rdvJump);
        [150, 500, 1200, 2500].forEach(function (ms) { window.setTimeout(rdvJump, ms); });
      }
    } else {
      root.classList.remove('is-idle');
      show(0, false, true);
    }

    /* Telefonda alttaki "Randevu Oluştur" çubuğu (2026-10-06): form ekranda
       değilken görünür; form görünür alana girince gizlenir (alanları
       örtmesin). Dokununca: form kapalıysa Başlayalım'a basılmış gibi açar,
       açıksa forma yumuşak kaydırır. Masaüstünde CSS ile hiç görünmez. */
    var sticky = root.querySelector('[data-rdv-sticky]');
    if (sticky && stage) {
      var stickyBtn = sticky.querySelector('[data-rdv-sticky-btn]');
      var stickyTick = false;
      var stickyCheck = function () {
        stickyTick = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var open = !root.classList.contains('is-idle');
        /* sorular + Randevu Notu kartı birlikte: kart ekrandayken de gizli kalsın */
        var area = root.querySelector('.rdv__cols') || stage;
        var r = area.getBoundingClientRect();
        var formInView = open && r.top < vh * 0.9 && r.bottom > 80;
        var on = !formInView;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        stickyBtn.tabIndex = on ? 0 : -1;
      };
      var stickyQueue = function () {
        if (!stickyTick) { stickyTick = true; window.requestAnimationFrame(stickyCheck); }
      };
      window.addEventListener('scroll', stickyQueue, { passive: true });
      window.addEventListener('resize', stickyQueue);
      window.addEventListener('load', stickyQueue);
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var start = begin && !begin.hidden ? begin.querySelector('[data-rdv-start]') : null;
        if (start) { start.click(); } else { park(); }
        sticky.classList.remove('is-on');
      });
      stickyCheck();
    }

    steps.forEach(function (step, i) {
      var slot = slotOf(step);
      Array.prototype.forEach.call(step.querySelectorAll('input[type="radio"]'), function (input) {
        input.addEventListener('change', function () {
          write(slot, input.value);
          if (slot === 'bulusma') { syncTime(); updateContactMode(); }
          markComplete();
          window.setTimeout(function () {
            var n = nextFrom(i);
            if (n !== i) show(n, true);
          }, 520);
        });
      });
    });

    /* the on-page way back — browser back stays what it is */
    Array.prototype.forEach.call(form.querySelectorAll('[data-rdv-back]'), function (btn) {
      btn.addEventListener('click', function () { show(prevFrom(at), true); });
    });

    /* the note is also the way back */
    Object.keys(lines).forEach(function (slot) {
      lines[slot].addEventListener('click', function () {
        if (root.classList.contains('is-idle')) return;
        var target = 'son';
        if (slot !== 'ad' && slot !== 'tel' && slot !== 'not') target = slot;
        for (var i = 0; i < steps.length; i++) {
          if (slotOf(steps[i]) === target && active(steps[i])) { show(i, true); return; }
        }
      });
    });
  })();

})();